export type SubTopicObject = {
    Name: string;
    ParentTopicId: number;
    SubTopicId: number;
};

export type TopicObject = {
    Name: string;
    SubTopics: SubTopicObject[];
    TopicId: number;
};

export const topics = [
    {
        Name: "Sports",
        SubTopics: [
            { Name: "Car Sports", ParentTopicId: 1, SubTopicId: 10 },
            { Name: "Athletics", ParentTopicId: 1, SubTopicId: 11 },
            { Name: "Rugby", ParentTopicId: 1, SubTopicId: 12 },
            { Name: "Boxing", ParentTopicId: 1, SubTopicId: 13 },
            { Name: "Hockey", ParentTopicId: 1, SubTopicId: 14 },
            { Name: "Field Hockey", ParentTopicId: 1, SubTopicId: 15 },
            { Name: "Ice Hockey", ParentTopicId: 1, SubTopicId: 16 },
            { Name: "Golf", ParentTopicId: 1, SubTopicId: 17 },
            { Name: "Table tennis", ParentTopicId: 1, SubTopicId: 18 },
            { Name: "Baseball", ParentTopicId: 1, SubTopicId: 19 },
            { Name: "Wrestling", ParentTopicId: 1, SubTopicId: 20 },
            { Name: "Water Polo", ParentTopicId: 1, SubTopicId: 97 },
            { Name: "Hurling", ParentTopicId: 1, SubTopicId: 98 },
            { Name: "Skiing", ParentTopicId: 1, SubTopicId: 99 },
            { Name: "Badminton", ParentTopicId: 1, SubTopicId: 100 },
            {
                Name: "MMA (Mixed Martial Arts)",
                ParentTopicId: 1,
                SubTopicId: 101
            },
            { Name: "Bowling", ParentTopicId: 1, SubTopicId: 102 },
            { Name: "Handball", ParentTopicId: 1, SubTopicId: 103 },
            { Name: "Track and Field", ParentTopicId: 1, SubTopicId: 104 },
            { Name: "Lacrosse", ParentTopicId: 1, SubTopicId: 105 },
            { Name: "Cycling", ParentTopicId: 1, SubTopicId: 106 },
            { Name: "Hunting", ParentTopicId: 1, SubTopicId: 107 }
        ],
        TopicId: 1
    },
    {
        Name: "Technology",
        SubTopics: [
            { Name: "Web", ParentTopicId: 2, SubTopicId: 108 },
            { Name: "Network", ParentTopicId: 2, SubTopicId: 109 },
            { Name: "Database", ParentTopicId: 2, SubTopicId: 110 },
            { Name: "Computer System", ParentTopicId: 2, SubTopicId: 111 },
            { Name: "Automation", ParentTopicId: 2, SubTopicId: 112 },
            {
                Name: "Artificial intelligence",
                ParentTopicId: 2,
                SubTopicId: 113
            },
            { Name: "Augmented reality", ParentTopicId: 2, SubTopicId: 114 },
            { Name: "virtual reality", ParentTopicId: 2, SubTopicId: 115 },
            { Name: "Wireless", ParentTopicId: 2, SubTopicId: 116 },
            { Name: "Drones", ParentTopicId: 2, SubTopicId: 117 },
            { Name: "Biometrics", ParentTopicId: 2, SubTopicId: 118 },
            { Name: "Quantum computing", ParentTopicId: 2, SubTopicId: 119 }
        ],
        TopicId: 2
    },
    {
        Name: "Media",
        SubTopics: [
            { Name: "Motion Pictures", ParentTopicId: 3, SubTopicId: 120 },
            { Name: "Cinema", ParentTopicId: 3, SubTopicId: 121 },
            { Name: "Channels", ParentTopicId: 3, SubTopicId: 122 },
            { Name: "Applications", ParentTopicId: 3, SubTopicId: 123 },
            { Name: "Advertisement", ParentTopicId: 3, SubTopicId: 124 },
            { Name: "Live Video", ParentTopicId: 3, SubTopicId: 125 },
            { Name: "Radio", ParentTopicId: 3, SubTopicId: 126 },
            { Name: "Magazines", ParentTopicId: 3, SubTopicId: 127 },
            { Name: "Books", ParentTopicId: 3, SubTopicId: 128 },
            { Name: "Ebooks", ParentTopicId: 3, SubTopicId: 129 },
            { Name: "Press", ParentTopicId: 3, SubTopicId: 130 },
            { Name: "Documentary", ParentTopicId: 3, SubTopicId: 131 },
            { Name: "Games", ParentTopicId: 3, SubTopicId: 132 },
            { Name: "Entertainment", ParentTopicId: 3, SubTopicId: 133 }
        ],
        TopicId: 3
    },
    {
        Name: "Information Security",
        SubTopics: [
            { Name: "Network attack", ParentTopicId: 4, SubTopicId: 135 },
            { Name: "Asset security", ParentTopicId: 4, SubTopicId: 137 },
            {
                Name: "Security and risk management",
                ParentTopicId: 4,
                SubTopicId: 138
            },
            { Name: "access management", ParentTopicId: 4, SubTopicId: 139 },
            { Name: "Security engineering", ParentTopicId: 4, SubTopicId: 140 },
            { Name: "Software", ParentTopicId: 4, SubTopicId: 141 },
            { Name: "Communication", ParentTopicId: 4, SubTopicId: 142 },
            { Name: "network security", ParentTopicId: 4, SubTopicId: 143 },
            { Name: "Security operations", ParentTopicId: 4, SubTopicId: 144 },
            { Name: "Security assessment", ParentTopicId: 4, SubTopicId: 145 },
            { Name: "Cryptography", ParentTopicId: 4, SubTopicId: 146 },
            { Name: "Viruses and worms", ParentTopicId: 4, SubTopicId: 148 },
            { Name: "Botnets", ParentTopicId: 4, SubTopicId: 149 },
            { Name: "DDoS attacks", ParentTopicId: 4, SubTopicId: 150 },
            { Name: "Ransomware", ParentTopicId: 4, SubTopicId: 151 },
            { Name: "Exploit kits", ParentTopicId: 4, SubTopicId: 152 },
            { Name: "Breaching", ParentTopicId: 4, SubTopicId: 153 },
            { Name: "Malvertising", ParentTopicId: 4, SubTopicId: 154 },
            { Name: "Development Security", ParentTopicId: 4, SubTopicId: 155 }
        ],
        TopicId: 4
    },
    {
        Name: "Medical",
        SubTopics: [
            { Name: "Emergency Medicine", ParentTopicId: 5, SubTopicId: 167 },
            { Name: "Internet Medicine", ParentTopicId: 5, SubTopicId: 168 },
            { Name: "HealthCare system", ParentTopicId: 5, SubTopicId: 169 },
            {
                Name: "HealthCare Technology",
                ParentTopicId: 5,
                SubTopicId: 170
            },
            { Name: "ALLERGY & IMMUNOLOGY", ParentTopicId: 5, SubTopicId: 171 },
            { Name: "ANESTHESIOLOGY", ParentTopicId: 5, SubTopicId: 172 },
            { Name: "DERMATOLOGY", ParentTopicId: 5, SubTopicId: 173 },
            { Name: "DIAGNOSTIC RADIOLOGY", ParentTopicId: 5, SubTopicId: 174 },
            { Name: "MEDICAL GENETICS", ParentTopicId: 5, SubTopicId: 175 },
            { Name: "NEUROLOGY", ParentTopicId: 5, SubTopicId: 176 },
            { Name: "NUCLEAR MEDICINE", ParentTopicId: 5, SubTopicId: 177 },
            {
                Name: "OBSTETRICS AND GYNECOLOGY",
                ParentTopicId: 5,
                SubTopicId: 178
            },
            { Name: "OPHTHALMOLOGY", ParentTopicId: 5, SubTopicId: 179 },
            { Name: "PATHOLOGY", ParentTopicId: 5, SubTopicId: 180 },
            { Name: "PEDIATRICS", ParentTopicId: 5, SubTopicId: 181 },
            { Name: "PHYSICAL MEDICINE", ParentTopicId: 5, SubTopicId: 182 },
            { Name: "PREVENTIVE MEDICINE", ParentTopicId: 5, SubTopicId: 183 },
            { Name: "PSYCHIATRY", ParentTopicId: 5, SubTopicId: 184 },
            { Name: "RADIATION ONCOLOGY", ParentTopicId: 5, SubTopicId: 185 },
            { Name: "UROLOGY", ParentTopicId: 5, SubTopicId: 186 }
        ],
        TopicId: 5
    },
    {
        Name: "Natural",
        SubTopics: [
            { Name: "earthquakes", ParentTopicId: 6, SubTopicId: 187 },
            { Name: "famines", ParentTopicId: 6, SubTopicId: 188 },
            { Name: "eruptions", ParentTopicId: 6, SubTopicId: 189 },
            { Name: "wildfires", ParentTopicId: 6, SubTopicId: 190 },
            {
                Name: "avalanches landslides",
                ParentTopicId: 6,
                SubTopicId: 191
            },
            { Name: "blizzards", ParentTopicId: 6, SubTopicId: 192 },
            { Name: "floods", ParentTopicId: 6, SubTopicId: 193 },
            { Name: "heat waves", ParentTopicId: 6, SubTopicId: 194 },
            { Name: "pandemics", ParentTopicId: 6, SubTopicId: 195 },
            { Name: "Tornadoes", ParentTopicId: 6, SubTopicId: 196 },
            { Name: "volcanic eruptions", ParentTopicId: 6, SubTopicId: 197 }
        ],
        TopicId: 6
    },
    {
        Name: "Tourism",
        SubTopics: [
            { Name: "amusement parks", ParentTopicId: 9, SubTopicId: 209 },
            { Name: "beaches", ParentTopicId: 9, SubTopicId: 210 },
            { Name: "botanical gardens", ParentTopicId: 9, SubTopicId: 211 },
            { Name: "hotels", ParentTopicId: 9, SubTopicId: 212 },
            { Name: "casinos", ParentTopicId: 9, SubTopicId: 213 },
            { Name: "castles", ParentTopicId: 9, SubTopicId: 214 },
            { Name: "festivals", ParentTopicId: 9, SubTopicId: 215 },
            { Name: "forts", ParentTopicId: 9, SubTopicId: 216 },
            { Name: "parks", ParentTopicId: 9, SubTopicId: 217 },
            {
                Name: "ski areas and resorts",
                ParentTopicId: 9,
                SubTopicId: 218
            },
            { Name: "Zoos", ParentTopicId: 9, SubTopicId: 219 },
            { Name: "Religious", ParentTopicId: 9, SubTopicId: 220 },
            { Name: "Special events", ParentTopicId: 9, SubTopicId: 221 },
            { Name: "Food and Drinks", ParentTopicId: 9, SubTopicId: 223 },
            { Name: "Activities", ParentTopicId: 9, SubTopicId: 224 },
            { Name: "Services", ParentTopicId: 9, SubTopicId: 225 },
            { Name: "Mobility", ParentTopicId: 9, SubTopicId: 226 },
            { Name: "Exhibitions", ParentTopicId: 9, SubTopicId: 227 },
            { Name: "Geography", ParentTopicId: 9, SubTopicId: 228 },
            { Name: "Travel", ParentTopicId: 9, SubTopicId: 229 },
            { Name: "Travel technology", ParentTopicId: 9, SubTopicId: 230 },
            { Name: "Seasons", ParentTopicId: 9, SubTopicId: 231 },
            { Name: "Sightmap", ParentTopicId: 9, SubTopicId: 232 }
        ],
        TopicId: 9
    },
    {
        Name: "Environment",
        SubTopics: [
            { Name: "Deforestation", ParentTopicId: 233, SubTopicId: 235 },
            { Name: "Soil Degradation", ParentTopicId: 233, SubTopicId: 236 },
            { Name: "Water Crisis", ParentTopicId: 233, SubTopicId: 237 },
            { Name: "Air pollution", ParentTopicId: 233, SubTopicId: 238 },
            { Name: "Water pollution", ParentTopicId: 233, SubTopicId: 239 },
            {
                Name: "Environmental disasters",
                ParentTopicId: 233,
                SubTopicId: 240
            },
            {
                Name: "Environmental economics",
                ParentTopicId: 233,
                SubTopicId: 241
            },
            {
                Name: "Environmental education",
                ParentTopicId: 233,
                SubTopicId: 242
            },
            {
                Name: "Environmental ethics",
                ParentTopicId: 233,
                SubTopicId: 243
            },
            { Name: "Forests", ParentTopicId: 233, SubTopicId: 244 },
            { Name: "Ground pollution", ParentTopicId: 233, SubTopicId: 245 },
            { Name: "Oceans", ParentTopicId: 233, SubTopicId: 246 }
        ],
        TopicId: 233
    },
    {
        Name: "Business",
        SubTopics: [
            { Name: "Real-estate", ParentTopicId: 234, SubTopicId: 247 },
            { Name: "Utilities", ParentTopicId: 234, SubTopicId: 248 },
            { Name: "Transportation", ParentTopicId: 234, SubTopicId: 249 },
            { Name: "Retailers", ParentTopicId: 234, SubTopicId: 250 },
            { Name: "Manufacturing", ParentTopicId: 234, SubTopicId: 251 },
            { Name: "Mining", ParentTopicId: 234, SubTopicId: 252 },
            { Name: "Agriculture", ParentTopicId: 234, SubTopicId: 253 },
            { Name: "Educations", ParentTopicId: 234, SubTopicId: 254 },
            { Name: "Management", ParentTopicId: 234, SubTopicId: 255 },
            { Name: "Business Services", ParentTopicId: 234, SubTopicId: 256 },
            { Name: "Trade", ParentTopicId: 234, SubTopicId: 257 },
            { Name: "Global Trading", ParentTopicId: 234, SubTopicId: 258 },
            { Name: "Shipping", ParentTopicId: 234, SubTopicId: 259 },
            { Name: "Internet", ParentTopicId: 234, SubTopicId: 260 },
            { Name: "Companies", ParentTopicId: 234, SubTopicId: 261 },
            { Name: "Crises", ParentTopicId: 234, SubTopicId: 262 },
            { Name: "Programs", ParentTopicId: 234, SubTopicId: 263 },
            { Name: "Non profit", ParentTopicId: 234, SubTopicId: 264 },
            { Name: "Products", ParentTopicId: 234, SubTopicId: 265 },
            {
                Name: "Construction and engineering",
                ParentTopicId: 234,
                SubTopicId: 266
            },
            { Name: "Wholesale", ParentTopicId: 234, SubTopicId: 267 },
            { Name: "Distributions", ParentTopicId: 234, SubTopicId: 268 }
        ],
        TopicId: 234
    },
    {
        Name: "Cryptocurrencies",
        SubTopics: [
            { Name: "Ada cryptocurrency", ParentTopicId: 10, SubTopicId: 270 },
            {
                Name: "Bitcoin cryptocurrency",
                ParentTopicId: 10,
                SubTopicId: 271
            },
            {
                Name: "Chainlink cryptocurrency",
                ParentTopicId: 10,
                SubTopicId: 272
            },
            { Name: "Dash cryptocurrency", ParentTopicId: 10, SubTopicId: 273 },
            {
                Name: "Decred cryptocurrency",
                ParentTopicId: 10,
                SubTopicId: 274
            },
            {
                Name: "Dogecoin cryptocurrency",
                ParentTopicId: 10,
                SubTopicId: 275
            },
            {
                Name: "Electroneum cryptocurrency",
                ParentTopicId: 10,
                SubTopicId: 276
            },
            {
                Name: "EOSIO cryptocurrency",
                ParentTopicId: 10,
                SubTopicId: 277
            },
            {
                Name: "Ethereum cryptocurrency",
                ParentTopicId: 10,
                SubTopicId: 278
            },
            { Name: "IOTA cryptocurrency", ParentTopicId: 10, SubTopicId: 279 },
            {
                Name: "Litecoin cryptocurrency",
                ParentTopicId: 10,
                SubTopicId: 280
            },
            {
                Name: "Matic Network cryptocurrency",
                ParentTopicId: 10,
                SubTopicId: 281
            },
            {
                Name: "Monero cryptocurrency",
                ParentTopicId: 10,
                SubTopicId: 282
            },
            { Name: "NEO cryptocurrency", ParentTopicId: 10, SubTopicId: 283 },
            {
                Name: "Ripple cryptocurrency",
                ParentTopicId: 10,
                SubTopicId: 284
            },
            {
                Name: "Stellar cryptocurrency",
                ParentTopicId: 10,
                SubTopicId: 285
            },
            {
                Name: "Tether cryptocurrency",
                ParentTopicId: 10,
                SubTopicId: 286
            },
            { Name: "TRON cryptocurrency", ParentTopicId: 10, SubTopicId: 287 },
            {
                Name: "Verge cryptocurrency",
                ParentTopicId: 10,
                SubTopicId: 288
            },
            {
                Name: "Zcash cryptocurrency",
                ParentTopicId: 10,
                SubTopicId: 289
            },
            { Name: "FinTech", ParentTopicId: 10, SubTopicId: 290 },
            { Name: "Investing", ParentTopicId: 10, SubTopicId: 291 },
            { Name: "Nonprofits", ParentTopicId: 10, SubTopicId: 292 },
            { Name: "Small business", ParentTopicId: 10, SubTopicId: 293 },
            { Name: "Startups", ParentTopicId: 10, SubTopicId: 294 },
            { Name: "Venture capital", ParentTopicId: 10, SubTopicId: 295 }
        ],
        TopicId: 10
    },
    {
        Name: "Business & finance",
        SubTopics: [
            { Name: "Business & finance", ParentTopicId: 11, SubTopicId: 296 },
            {
                Name: "Business & finance news",
                ParentTopicId: 11,
                SubTopicId: 297
            },
            {
                Name: "Business Opportunity",
                ParentTopicId: 11,
                SubTopicId: 298
            },
            { Name: "Accounting", ParentTopicId: 11, SubTopicId: 299 },
            { Name: "Advertising", ParentTopicId: 11, SubTopicId: 300 },
            { Name: "Marketing", ParentTopicId: 11, SubTopicId: 301 }
        ],
        TopicId: 11
    },
    {
        Name: "Education",
        SubTopics: [
            { Name: "Education", ParentTopicId: 12, SubTopicId: 302 },
            { Name: "College life", ParentTopicId: 12, SubTopicId: 303 },
            { Name: "Graduate school", ParentTopicId: 12, SubTopicId: 304 },
            { Name: "Homeschooling", ParentTopicId: 12, SubTopicId: 305 },
            { Name: "Language learning", ParentTopicId: 12, SubTopicId: 306 },
            { Name: "Online education", ParentTopicId: 12, SubTopicId: 307 },
            { Name: "Genealogy", ParentTopicId: 12, SubTopicId: 308 },
            { Name: "Marketing", ParentTopicId: 12, SubTopicId: 309 }
        ],
        TopicId: 12
    },
    {
        Name: "Game developers & publishers",
        SubTopics: [
            {
                Name: "Game developers & publishers",
                ParentTopicId: 13,
                SubTopicId: 310
            },
            { Name: "Activision", ParentTopicId: 13, SubTopicId: 311 },
            { Name: "Bethesda", ParentTopicId: 13, SubTopicId: 312 },
            {
                Name: "Blizzard Entertainment",
                ParentTopicId: 13,
                SubTopicId: 313
            },
            { Name: "Bungie", ParentTopicId: 13, SubTopicId: 314 },
            { Name: "Capcom", ParentTopicId: 13, SubTopicId: 315 },
            {
                Name: "Electronic Arts (EA)",
                ParentTopicId: 13,
                SubTopicId: 316
            },
            { Name: "Epic Games", ParentTopicId: 13, SubTopicId: 317 },
            { Name: "Nintendo", ParentTopicId: 13, SubTopicId: 318 },
            { Name: "PlayStation", ParentTopicId: 13, SubTopicId: 319 },
            { Name: "Riot Games", ParentTopicId: 13, SubTopicId: 320 },
            { Name: "Rockstar Games", ParentTopicId: 13, SubTopicId: 321 },
            { Name: "Sega", ParentTopicId: 13, SubTopicId: 322 },
            { Name: "Square Enix", ParentTopicId: 13, SubTopicId: 323 },
            { Name: "Ubisoft", ParentTopicId: 13, SubTopicId: 324 },
            { Name: "Valve Corporation", ParentTopicId: 13, SubTopicId: 325 },
            { Name: "Xbox", ParentTopicId: 13, SubTopicId: 326 },
            { Name: "Gaming news", ParentTopicId: 13, SubTopicId: 327 }
        ],
        TopicId: 13
    },
    {
        Name: "Gaming personalities & esports players",
        SubTopics: [
            { Name: "H3CZ", ParentTopicId: 14, SubTopicId: 328 },
            { Name: "Jacksepticeye", ParentTopicId: 14, SubTopicId: 329 },
            { Name: "Ninja", ParentTopicId: 14, SubTopicId: 330 },
            { Name: "PewDiePie", ParentTopicId: 14, SubTopicId: 331 },
            { Name: "Pokimane", ParentTopicId: 14, SubTopicId: 332 },
            { Name: "Tfue", ParentTopicId: 14, SubTopicId: 333 },
            { Name: "Vikkstar", ParentTopicId: 14, SubTopicId: 334 },
            { Name: "Tabletop gaming", ParentTopicId: 14, SubTopicId: 335 },
            { Name: "Board games", ParentTopicId: 14, SubTopicId: 336 },
            {
                Name: "Tabletop role-playing games",
                ParentTopicId: 14,
                SubTopicId: 337
            },
            { Name: "Dungeons & Dragons", ParentTopicId: 14, SubTopicId: 338 },
            { Name: "Pathfinder", ParentTopicId: 14, SubTopicId: 339 },
            { Name: "Trading card games", ParentTopicId: 14, SubTopicId: 340 },
            { Name: "Gwent", ParentTopicId: 14, SubTopicId: 341 },
            {
                Name: "Magic: The Gathering",
                ParentTopicId: 14,
                SubTopicId: 342
            },
            {
                Name: "Pokémon Trading Card Game",
                ParentTopicId: 14,
                SubTopicId: 343
            },
            { Name: "Traditional games", ParentTopicId: 14, SubTopicId: 344 },
            { Name: "Chess", ParentTopicId: 14, SubTopicId: 345 },
            { Name: "Poker", ParentTopicId: 14, SubTopicId: 346 }
        ],
        TopicId: 14
    },
    {
        Name: "Video game platforms & hardware",
        SubTopics: [
            {
                Name: "Video game platforms & hardware",
                ParentTopicId: 15,
                SubTopicId: 347
            },
            { Name: "Arcade gaming", ParentTopicId: 15, SubTopicId: 348 },
            { Name: "Cloud gaming", ParentTopicId: 15, SubTopicId: 349 },
            { Name: "Mobile gaming", ParentTopicId: 15, SubTopicId: 350 },
            { Name: "Nintendo 3DS", ParentTopicId: 15, SubTopicId: 351 },
            { Name: "Nintendo Switch", ParentTopicId: 15, SubTopicId: 352 },
            { Name: "Online gaming", ParentTopicId: 15, SubTopicId: 353 },
            { Name: "PC gaming", ParentTopicId: 15, SubTopicId: 354 },
            { Name: "PlayStation 4", ParentTopicId: 15, SubTopicId: 355 },
            { Name: "PlayStation 5", ParentTopicId: 15, SubTopicId: 356 },
            { Name: "PlayStation Vita", ParentTopicId: 15, SubTopicId: 357 },
            { Name: "Xbox One", ParentTopicId: 15, SubTopicId: 358 },
            { Name: "Movies and TV", ParentTopicId: 15, SubTopicId: 359 }
        ],
        TopicId: 15
    },
    {
        Name: "Movies and TV",
        SubTopics: [
            { Name: "Movies", ParentTopicId: 16, SubTopicId: 360 },
            {
                Name: "Action & adventure films",
                ParentTopicId: 16,
                SubTopicId: 361
            },
            { Name: "Animated films", ParentTopicId: 16, SubTopicId: 362 },
            { Name: "Bollywood films", ParentTopicId: 16, SubTopicId: 363 },
            { Name: "Comedy films", ParentTopicId: 16, SubTopicId: 364 },
            { Name: "Documentary films", ParentTopicId: 16, SubTopicId: 365 },
            { Name: "Drama films", ParentTopicId: 16, SubTopicId: 366 },
            { Name: "Horror films", ParentTopicId: 16, SubTopicId: 367 },
            { Name: "Independent films", ParentTopicId: 16, SubTopicId: 368 },
            { Name: "Movie news", ParentTopicId: 16, SubTopicId: 369 },
            { Name: "Musicals", ParentTopicId: 16, SubTopicId: 370 },
            {
                Name: "Sci-fi & fantasy films",
                ParentTopicId: 16,
                SubTopicId: 371
            },
            { Name: "Screenwriting", ParentTopicId: 16, SubTopicId: 372 },
            { Name: "The Oscars", ParentTopicId: 16, SubTopicId: 373 },
            { Name: "TV shows ", ParentTopicId: 16, SubTopicId: 374 }
        ],
        TopicId: 16
    },
    {
        Name: "Music",
        SubTopics: [
            { Name: "Alternative", ParentTopicId: 17, SubTopicId: 375 },
            { Name: "Bollywood music", ParentTopicId: 17, SubTopicId: 376 },
            { Name: "C-pop", ParentTopicId: 17, SubTopicId: 377 },
            { Name: "Classic rock", ParentTopicId: 17, SubTopicId: 378 },
            { Name: "Classical music", ParentTopicId: 17, SubTopicId: 379 },
            { Name: "Country music", ParentTopicId: 17, SubTopicId: 380 },
            { Name: "Dance music", ParentTopicId: 17, SubTopicId: 381 },
            { Name: "Electronic music", ParentTopicId: 17, SubTopicId: 382 },
            { Name: "Experimental music", ParentTopicId: 17, SubTopicId: 383 },
            { Name: "Folk Music", ParentTopicId: 17, SubTopicId: 384 },
            { Name: "Hip-hop & rap", ParentTopicId: 17, SubTopicId: 385 },
            { Name: "J-pop", ParentTopicId: 17, SubTopicId: 386 },
            { Name: "Jazz", ParentTopicId: 17, SubTopicId: 387 },
            { Name: "K-hip hop", ParentTopicId: 17, SubTopicId: 388 },
            { Name: "K-pop", ParentTopicId: 17, SubTopicId: 389 },
            { Name: "Metal", ParentTopicId: 17, SubTopicId: 390 },
            { Name: "Music brands", ParentTopicId: 17, SubTopicId: 391 },
            { Name: "Music festivals", ParentTopicId: 17, SubTopicId: 392 },
            { Name: "Music news", ParentTopicId: 17, SubTopicId: 393 },
            { Name: "Musical instruments", ParentTopicId: 17, SubTopicId: 394 },
            { Name: "Drums", ParentTopicId: 17, SubTopicId: 395 },
            { Name: "Guitar", ParentTopicId: 17, SubTopicId: 396 },
            { Name: "Saxophone", ParentTopicId: 17, SubTopicId: 397 },
            { Name: "Opera", ParentTopicId: 17, SubTopicId: 398 },
            { Name: "Pop", ParentTopicId: 17, SubTopicId: 399 },
            { Name: "Reggaeton", ParentTopicId: 17, SubTopicId: 400 },
            { Name: "Rock", ParentTopicId: 17, SubTopicId: 401 }
        ],
        TopicId: 17
    },
    {
        Name: "News",
        SubTopics: [
            {
                Name: "Arts and culture news",
                ParentTopicId: 18,
                SubTopicId: 402
            },
            {
                Name: "Business & finance news",
                ParentTopicId: 18,
                SubTopicId: 403
            },
            { Name: "Gaming news", ParentTopicId: 18, SubTopicId: 404 },
            { Name: "Health news", ParentTopicId: 18, SubTopicId: 405 },
            { Name: "Local news", ParentTopicId: 18, SubTopicId: 406 },
            { Name: "Sports new", ParentTopicId: 18, SubTopicId: 407 },
            { Name: "Social media news", ParentTopicId: 18, SubTopicId: 408 },
            {
                Name: "Computers & IT Business",
                ParentTopicId: 18,
                SubTopicId: 409
            },
            { Name: "Economics", ParentTopicId: 18, SubTopicId: 410 },
            { Name: "General News", ParentTopicId: 18, SubTopicId: 411 },
            {
                Name: "Health, Medicine, Pharmacy Industry",
                ParentTopicId: 18,
                SubTopicId: 412
            },
            {
                Name: "Computers & IT Business",
                ParentTopicId: 18,
                SubTopicId: 413
            },
            {
                Name: "Marketing, Advertising Trade",
                ParentTopicId: 18,
                SubTopicId: 414
            },
            { Name: "Lifestyle", ParentTopicId: 18, SubTopicId: 415 }
        ],
        TopicId: 18
    },
    {
        Name: "COVID-19",
        SubTopics: [
            { Name: "COVID-19", ParentTopicId: 19, SubTopicId: 416 },
            {
                Name: "COVID-19: government and public officials",
                ParentTopicId: 19,
                SubTopicId: 417
            },
            {
                Name: "COVID-19: health experts",
                ParentTopicId: 19,
                SubTopicId: 418
            }
        ],
        TopicId: 19
    },
    {
        Name: "Entairtenment",
        SubTopics: [
            { Name: "Amusement Parks", ParentTopicId: 20, SubTopicId: 419 },
            { Name: "Circuses", ParentTopicId: 20, SubTopicId: 420 },
            { Name: "Cultural Events", ParentTopicId: 20, SubTopicId: 421 },
            { Name: "Dinner Theatre", ParentTopicId: 20, SubTopicId: 422 },
            { Name: "Fashion Shows", ParentTopicId: 20, SubTopicId: 423 },
            { Name: "Fireworks", ParentTopicId: 20, SubTopicId: 424 },
            {
                Name: "Improvisational Theatre",
                ParentTopicId: 20,
                SubTopicId: 425
            },
            { Name: "Magic Shows", ParentTopicId: 20, SubTopicId: 426 },
            { Name: "Movies", ParentTopicId: 20, SubTopicId: 427 },
            { Name: "Music", ParentTopicId: 20, SubTopicId: 428 },
            { Name: "Operas", ParentTopicId: 20, SubTopicId: 429 },
            { Name: "Podcasts", ParentTopicId: 20, SubTopicId: 430 },
            { Name: "Social Media", ParentTopicId: 20, SubTopicId: 431 },
            { Name: "Storytelling", ParentTopicId: 20, SubTopicId: 432 },
            { Name: "Television", ParentTopicId: 20, SubTopicId: 433 },
            { Name: "Theme Parks", ParentTopicId: 20, SubTopicId: 434 },
            { Name: "Video", ParentTopicId: 20, SubTopicId: 435 },
            { Name: "Water Parks", ParentTopicId: 20, SubTopicId: 436 },
            { Name: "Art Exhibits", ParentTopicId: 20, SubTopicId: 437 },
            { Name: "Comedy Clubs", ParentTopicId: 20, SubTopicId: 438 },
            { Name: "Dance", ParentTopicId: 20, SubTopicId: 439 },
            { Name: "Fairs", ParentTopicId: 20, SubTopicId: 440 },
            { Name: "Festivals", ParentTopicId: 20, SubTopicId: 441 },
            {
                Name: "Immersive Experiences",
                ParentTopicId: 20,
                SubTopicId: 442
            },
            { Name: "Karaoke", ParentTopicId: 20, SubTopicId: 443 },
            { Name: "Media", ParentTopicId: 20, SubTopicId: 444 },
            { Name: "Museums", ParentTopicId: 20, SubTopicId: 445 },
            { Name: "Nightclubs", ParentTopicId: 20, SubTopicId: 446 },
            { Name: "Performance Art", ParentTopicId: 20, SubTopicId: 447 },
            { Name: "Radio", ParentTopicId: 20, SubTopicId: 448 },
            { Name: "Spectator Sports", ParentTopicId: 20, SubTopicId: 449 },
            { Name: "Streaming Media", ParentTopicId: 20, SubTopicId: 450 },
            { Name: "Theatre", ParentTopicId: 20, SubTopicId: 451 },
            { Name: "Trade Shows", ParentTopicId: 20, SubTopicId: 452 },
            { Name: "Video Games", ParentTopicId: 20, SubTopicId: 453 }
        ],
        TopicId: 20
    }
];

let subtopics: SubTopicObject[] = [];
topics.map((t) => (subtopics = [...subtopics, ...t.SubTopics]));

export { subtopics };
